/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Portability_DescInputs */

const en_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) — Receive your data in a structured, machine-readable format`)
};

const de_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) -- Erhalten Sie Ihre Daten in einem strukturierten, maschinenlesbaren Format`)
};

const fr_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) -- Recevoir vos données dans un format structuré et lisible par machine`)
};

const es_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) -- Recibir sus datos en un formato estructurado y legible por máquina`)
};

const it_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) — Ricevere i tuoi dati in un formato strutturato e leggibile da una macchina`)
};

const nl_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) — Uw gegevens ontvangen in een gestructureerd, machineleesbaar formaat`)
};

const pl_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) — Otrzymanie swoich danych w ustrukturyzowanym, nadającym się do odczytu maszynowego formacie`)
};

const fi_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (artikla 20) — Vastaanota tietosi jäsennellyssä, koneluettavassa muodossa`)
};

const da_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) — Modtag dine data i et struktureret, maskinlæsbart format`)
};

const sv_privacy_rights_item_portability_desc = /** @type {(inputs: Privacy_Rights_Item_Portability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 20) — Ta emot dina data i ett strukturerat, maskinläsbart format`)
};

/**
* | output |
* | --- |
* | "(Art. 20) — Receive your data in a structured, machine-readable format" |
*
* @param {Privacy_Rights_Item_Portability_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_portability_desc = /** @type {((inputs?: Privacy_Rights_Item_Portability_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Portability_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_portability_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_portability_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_portability_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_portability_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_portability_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_portability_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_portability_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_portability_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_portability_desc(inputs)
	return en_privacy_rights_item_portability_desc(inputs)
});